import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from "react";
import { EvSearchApi } from "apiclient/api/EvSearchApi";
import { withLayoutStartPage } from "components/fragments/global/Layout";
import { transformSearchFields, transformQuickAndExpertState } from "components/fragments/Search/tools";
import { buildBaseUrl } from "components/common/utils/EVUrl";
import useNotify from "services/notification";
import MostRecentSearches from "components/fragments/Search/shared-components/MostRecentSearches";
import useQuickAndExpertContext from "contexts/StartPage/useQuickAndExpertContext";
import { Events } from "services/adobeAnalytics";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { useSearchParams } from "next/navigation";
import Skeleton from "components/fragments/Search/Quick/Skeleton";
var api = new EvSearchApi();
function Quick(_ref) {
  var getContext = _ref.getContext;
  var notify = useNotify();
  var _getContext = getContext(),
    state = _getContext.state,
    call = _getContext.call;
  var _useQuickAndExpertCon = useQuickAndExpertContext(),
    quickAndExpertState = _useQuickAndExpertCon.quickAndExpertState;
  var searchFields = state.searchFields,
    status = state.status,
    error = state.error,
    redirectURL = state.redirectURL;
  var searchParams = useSearchParams();
  var errorCode = searchParams.get("errorCode");
  useEffect(function () {
    if (errorCode === "1016") {
      notify.error({
        text: "This search is no longer available or the search ID is invalid"
      });
    }
  }, [errorCode]);
  useEffect(function () {
    Events.startPage.startPageView();
  }, []);
  useEffect(function () {
    var _error$error;
    if (status === "error") notify.error({
      text: "".concat((_error$error = error === null || error === void 0 ? void 0 : error.error) !== null && _error$error !== void 0 ? _error$error : error)
    });
  }, [status]);
  useEffect(function () {
    if (!(searchFields !== null && searchFields !== void 0 && searchFields.length)) return;
    var options = _objectSpread(_objectSpread({
      searchtype: "Quick"
    }, transformQuickAndExpertState(quickAndExpertState)), transformSearchFields(searchFields));
    call(api.submitSearch(options).then(function (response) {
      return {
        redirectURL: response.redirectURL
      };
    })["catch"](function (e) {
      throw new Error(e.response.body.message);
    }));
  }, [searchFields]);
  if (redirectURL) {
    var _window, _window$location, _window$location$assi;
    var _url = new URL(redirectURL, buildBaseUrl());
    (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$assi = _window$location.assign) === null || _window$location$assi === void 0 ? void 0 : _window$location$assi.call(_window$location, _url);
  }
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    maxWidth: "lg",
    margin: "auto"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    xs: 1.5,
    item: true
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    xs: 9,
    item: true
  }, /*#__PURE__*/React.createElement(MostRecentSearches, null)), /*#__PURE__*/React.createElement(ELSGrid, {
    xs: 1.5,
    item: true
  }));
}
var withLayoutQuickPage = withLayoutStartPage(Quick, {
  page: "Quick"
});
withLayoutQuickPage.skeleton = Skeleton;
withLayoutQuickPage.title = "Quick Search";
export default withLayoutQuickPage;